export const categoryEnums = [
	{
		id: "Welfare",
		name: "Welfare",
	},
	{
		id: "VIP",
		name: "VIP",
	},
];
